import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Copy, Facebook, Linkedin } from "lucide-react";
import { useSelector } from "react-redux";
import { shareText } from "i18n/blog";
import toast from "react-hot-toast";

const ShareModal = ({ open, onClose, url }) => {
  const lang = useSelector((state) => state.language.lang);
  const t = shareText[lang];

  if (!open) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(url);
    toast.success(t.copied); // ✅ bilingual toast
  };

  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* BACKDROP */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 bg-black/40"
            onClick={onClose}
          />

          {/* MODAL */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 40 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.3 }}
            className="relative bg-white rounded-2xl p-6 w-[90%] max-w-md shadow-xl z-10"
          >
            {/* CLOSE */}
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-gray-500 hover:text-black"
            >
              <X size={18} />
            </button>

            {/* TITLE */}
            <h3 className="text-lg font-semibold mb-4 text-neonYellow">
              {t.title}
            </h3>

            {/* SOCIAL */}
            <div className="flex gap-4 mb-4">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-blue-500 text-white rounded-full hover:opacity-90 transition"
              >
                <Facebook size={18} />
              </a>

              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-blue-700 text-white rounded-full hover:opacity-90 transition"
              >
                <Linkedin size={18} />
              </a>
            </div>

            {/* COPY */}
            <div className="flex items-center border border-neonYellow rounded-lg overflow-hidden">
              <input
                value={url}
                readOnly
                className="flex-1 px-3 py-2 text-sm outline-none text-text"
              />
              <button
                onClick={handleCopy}
                className="px-4 py-1 bg-neonYellow hover:bg-gray-200 text-sm text-white rounded-lg mr-2 "
              >
                {t.copy}
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default ShareModal;
